module.exports = __webpack_public_path__ + "img/phone.da980e51.png";